import { Flex, Form, FormContext } from 'dash-ui';
import { useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { FormFields } from 'containers/properties/PropertyGeneralInformation/components/PropertyGeneralInfoForm/constants/constants';
import useValidation from 'containers/properties/PropertyGeneralInformation/components/PropertyGeneralInfoForm/hooks/useValidation';
import { useGetUsStatesQuery } from 'gql/generated.graphql';

const StateSelect = () => {
  const { t } = useTranslation(['forms', 'common', 'pages']);
  const { formState, formErrors, stateHandlers } = useContext(FormContext);
  const valid = useValidation();
  const { data: statesData } = useGetUsStatesQuery();
  const statesOptions = useMemo(() => {
    const states = statesData?.getUSStates || [];
    return states.map(({ name }) => ({
      value: name,
      label: name,
    }));
  }, [statesData]);
  const onSelect = (fieldName: FormFields) => (value: string) => {
    stateHandlers[fieldName](value);
    stateHandlers[FormFields.County](null);
    stateHandlers[FormFields.Market](null);
    valid(fieldName, value || '');
  };

  return (
    <Flex flexDirection="column" flex={1} mr={2}>
      <Form.Label required>{t('forms:labels.state')}</Form.Label>
      <Form.Select
        menuPortalZIndex="auto"
        value={formState.state}
        options={statesOptions}
        placeholder={t('forms:placeholders.selectOne')}
        w="100%"
        onChanged={onSelect(FormFields.State)}
        $errorType={formErrors[FormFields.State]?.type}
      />
      <Form.Feedback $errorType={formErrors[FormFields.State]?.type}>
        {formErrors[FormFields.State]?.message}
      </Form.Feedback>
    </Flex>
  );
};

export default StateSelect;
